import loadable from '@loadable/component';
import Loading from '../components/Loader';

const ReceiptModal = loadable(
  () => import(/* webpackChunkName: "pay-modal" */ '../containers/ReceiptModal'),
  {
    fallback: Loading
  }
);

export default ReceiptModal;
